<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter001"><span class="item-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter002"><span class="item-title-text">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter003"><span class="item-title-text">Chapter 3</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter004"><span class="item-title-text">Chapter 4</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter005"><span class="item-title-text">Chapter 5</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/chapter006"><span class="item-title-text">Chapter 6</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter007" title="Link target outside of Sample"><span class="item-title-text">Chapter 7</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter008" title="Link target outside of Sample"><span class="item-title-text">Chapter 8</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter009" title="Link target outside of Sample"><span class="item-title-text">Chapter 9</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter010" title="Link target outside of Sample"><span class="item-title-text">Chapter 10</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter011" title="Link target outside of Sample"><span class="item-title-text">Chapter 11</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter012" title="Link target outside of Sample"><span class="item-title-text">Chapter 12</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter013" title="Link target outside of Sample"><span class="item-title-text">Chapter 13</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter014" title="Link target outside of Sample"><span class="item-title-text">Chapter 14</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter015" title="Link target outside of Sample"><span class="item-title-text">Chapter 15</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter016" title="Link target outside of Sample"><span class="item-title-text">Chapter 16</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter017" title="Link target outside of Sample"><span class="item-title-text">Chapter 17</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter018" title="Link target outside of Sample"><span class="item-title-text">Chapter 18</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter019" title="Link target outside of Sample"><span class="item-title-text">Chapter 19</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter020" title="Link target outside of Sample"><span class="item-title-text">Chapter 20</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter021" title="Link target outside of Sample"><span class="item-title-text">Chapter 21</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter022" title="Link target outside of Sample"><span class="item-title-text">Chapter 22</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter023" title="Link target outside of Sample"><span class="item-title-text">Chapter 23</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter024" title="Link target outside of Sample"><span class="item-title-text">Chapter 24</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter025" title="Link target outside of Sample"><span class="item-title-text">Chapter 25</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter026" title="Link target outside of Sample"><span class="item-title-text">Chapter 26</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter027" title="Link target outside of Sample"><span class="item-title-text">Chapter 27</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter028" title="Link target outside of Sample"><span class="item-title-text">Chapter 28</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter029" title="Link target outside of Sample"><span class="item-title-text">Chapter 29</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter030" title="Link target outside of Sample"><span class="item-title-text">Chapter 30</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter031" title="Link target outside of Sample"><span class="item-title-text">Chapter 31</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter032" title="Link target outside of Sample"><span class="item-title-text">Chapter 32</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter033" title="Link target outside of Sample"><span class="item-title-text">Chapter 33</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter034" title="Link target outside of Sample"><span class="item-title-text">Chapter 34</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter035" title="Link target outside of Sample"><span class="item-title-text">Chapter 35</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter036" title="Link target outside of Sample"><span class="item-title-text">Chapter 36</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter037" title="Link target outside of Sample"><span class="item-title-text">Chapter 37</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter038" title="Link target outside of Sample"><span class="item-title-text">Chapter 38</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter039" title="Link target outside of Sample"><span class="item-title-text">Chapter 39</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter040" title="Link target outside of Sample"><span class="item-title-text">Chapter 40</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/chapter041" title="Link target outside of Sample"><span class="item-title-text">Chapter 41</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/epilogue" title="Link target outside of Sample"><span class="item-title-text">Epilogue</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/queensofthecastleseries" title="Link target outside of Sample"><span class="item-title-text">Queens of the Castle Series</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/kingsofthecastle" title="Link target outside of Sample"><span class="item-title-text">Kings of the Castle</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/knightsofthecastle" title="Link target outside of Sample"><span class="item-title-text">Knights of the Castle</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/kingofdurabia" title="Link target outside of Sample"><span class="item-title-text">King of Durabia</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/knightofsouthholland" title="Link target outside of Sample"><span class="item-title-text">Knight of South Holland</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/transitionofpower" title="Link target outside of Sample"><span class="item-title-text">Transition of Power</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/opendoormarriage" title="Link target outside of Sample"><span class="item-title-text">Open Door Marriage</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/lovingmeforme" title="Link target outside of Sample"><span class="item-title-text">Loving Me for Me</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/thedaysofpleasureseries" title="Link target outside of Sample"><span class="item-title-text">The Days of Pleasure Series</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/aboutnaleighnakai" title="Link target outside of Sample"><span class="item-title-text">About Naleighna Kai</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/aboutkarendbradley" title="Link target outside of Sample"><span class="item-title-text">About Karen D. Bradley</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?030cc4e4